module.exports = __webpack_public_path__ + "img/gold_top_performer.080ba1ab.png";